import { createSlice } from '@reduxjs/toolkit'
import {
  fetchUsersTypesById,
  fetchUsersType,
  updateUsersTypes,
  updateStatusInUsersTypes,
  fetchAllDropdownsUsersTypes,
  exportetchUsersTypes
} from './thunk'

interface UserTypeState {
  usersTypesList: any[]
  rowCount: number
  loading: boolean
  error: string | null
  selectedOrganisation: any
  orgDropDown: any[]
  industryTypeDropDown: any[]
  orgCityDropDown: any[]
  orgStateDropDown: any[]
  usersDrop: any[]
  pincodeDropDown: any[]
  exportCSVLoading: boolean
  exportCSVError: string | null
}

const initialState: UserTypeState = {
  usersTypesList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedOrganisation: null,
  orgDropDown: [],
  usersDrop:[],
  industryTypeDropDown: [],
  orgCityDropDown: [],
  orgStateDropDown: [],
  pincodeDropDown: [],
  exportCSVLoading: false,
  exportCSVError: null
}

const usersTypeSlice = createSlice({
  name: 'usersType',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      // Fetch All Organisations
      .addCase(fetchUsersType.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchUsersType.fulfilled, (state, action) => {
        state.loading = false
        state.usersTypesList = Array.isArray(action.payload.data)
          ? action.payload.data
          : []
        state.rowCount = typeof action.payload.rowCount === 'number'
          ? action.payload.rowCount
          : 0
      })
      .addCase(fetchUsersType.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to fetch organisations'
      })

      // Fetch Organisation by ID
      .addCase(fetchUsersTypesById.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchUsersTypesById.fulfilled, (state, action) => {
        state.loading = false
        state.selectedOrganisation = action.payload
      })
      .addCase(fetchUsersTypesById.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

      // Update Organisation
      .addCase(updateUsersTypes.fulfilled, (state, action) => {
        if (!action.payload?.id) return
        state.usersTypesList = state.usersTypesList.map(org =>
          org.id === action.payload.id ? action.payload : org
        )
      })
      .addCase(updateUsersTypes.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to update organisation'
      })

      // Update Status
      .addCase(updateStatusInUsersTypes.fulfilled, (state, action) => {
        if (!action.payload?.id) return
        state.usersTypesList = state.usersTypesList.map(org =>
          org.id === action.payload.id ? action.payload : org
        )
      })
      .addCase(updateStatusInUsersTypes.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to update status'
      })

      // Dropdown Data
      .addCase(fetchAllDropdownsUsersTypes.fulfilled, (state, action) => {
        state.usersDrop = action.payload.usersRes || []
        state.industryTypeDropDown = action.payload.industryTypeDropDown || []
        state.orgCityDropDown = action.payload.orgCityDropDown || []
        state.orgStateDropDown = action.payload.orgStateDropDown || []
        state.pincodeDropDown = action.payload.pincodeDropDown || []
      })

      // Export Users Types (CSV or Excel)
      .addCase(exportetchUsersTypes.pending, state => {
        state.exportCSVLoading = true
        state.exportCSVError = null
      })
      .addCase(exportetchUsersTypes.fulfilled, state => {
        state.exportCSVLoading = false
      })
      .addCase(exportetchUsersTypes.rejected, (state, action) => {
        state.exportCSVLoading = false
        state.exportCSVError = action.error.message || 'Failed to export CSV'
      })
  }
})

export default usersTypeSlice.reducer
